import { render, staticRenderFns } from "./JbtRegister.vue?vue&type=template&id=416e5592&scoped=true&"
import script from "./JbtRegister.vue?vue&type=script&lang=js&"
export * from "./JbtRegister.vue?vue&type=script&lang=js&"
import style0 from "./JbtRegister.vue?vue&type=style&index=0&id=416e5592&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416e5592",
  null
  
)

export default component.exports